import type { EChartsOption } from 'echarts'
import { BarChart, LineChart } from 'echarts/charts'
import {
  AriaComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
} from 'echarts/components'
import * as echarts from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import ReactEChartsCore from 'echarts-for-react/lib/core'

// Registered here, not through @zealth/core/charts: the dashboard's chart set
// is its own and must not move when the product's does.
echarts.use([
  BarChart,
  LineChart,
  AriaComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
  CanvasRenderer,
])

type EChartProps = { option: EChartsOption; height: number }

/** Charts render at 1:1 with body copy: a fixed pixel height, full width. */
const EChart = ({ option, height }: EChartProps) => (
  <ReactEChartsCore
    echarts={echarts}
    option={option}
    notMerge
    lazyUpdate
    style={{ width: '100%', height }}
  />
)

export default EChart
